module.exports = __webpack_public_path__ + "img/IT0003124656021.d8922a11.png";